// import ColVisibilitySelector from "components/DataTable/ColVisibilitySelector";
import ItemActionsMenu from "components/DataTable/ItemActionsMenu";
import React from "react";
import Checkbox from "components/Checkbox/Checkbox";
import moment from 'moment';

const actionMenuDropDown = React.createRef();

export default {
    TABLE: {
        className: "data-table-documents",
        initialSortKey: "name",
        initialSortOrder: "asc"
    },

    COLUMN: [
        {
            label: "Row Selector",
            key: "row-selector",
            header: ({ customTableProps }) => {
                const isSelectedAll =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.rowsData &&
                    customTableProps.rowsData.length &&
                    customTableProps.selectedRows.length ===
                        customTableProps.rowsData.length
                        ? true
                        : false;
                return (
                    <Checkbox
                        checked={isSelectedAll}
                        onChange={() => customTableProps.doSelectAll()}
                        name="row-selector"
                    />
                );
            },
            className: "col-row-selector",
            format: ({ rowData, customTableProps }) => {
                const isSelected =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.selectedRows.includes(rowData)
                        ? true
                        : false;
                return (
                    <Checkbox
                        checked={isSelected}
                        onChange={() => customTableProps.onRowSelect({ rowData })}
                        name="row-selector"
                    />
                );
            },
            canBeHidden: false
        },
        {
            label: "Name",
            header: "NAME",
            key: "name",
            className: "name",
            sortable: true,
            format: ({ rowData, customTableProps }) => {
                let icon = '';

                if (rowData['type'] === 'folder'){
                    icon = <i className="fas fa-folder"/>
                }

                if (rowData['type'] === 'file'){
                    
                    if (rowData['file_type'] === 'text'){
                        if (rowData['folder_name'].endsWith(".pdf")){
                            icon = <i className="fas fa-file-pdf"></i>
                        }else{
                            icon = <i className="fas fa-file-word"></i>
                        }
                    }

                    if (rowData['file_type'] === 'spreadsheet'){
                        icon = <i className="fas fa-file-excel"></i>
                    }

                    if (rowData['file_type'] === 'presentation'){
                        icon = <i className="fas fa-file-powerpoint"></i>
                    }
                }

                return <span>{icon}{rowData["folder_name"]}</span>;
            }
        },
        {
            label: "Last Modified",
            header: "LAST MODIFIED",
            key: "last_modified",
            sortable: true,
            format: ({ rowData, customTableProps }) => {
                return <span>{ moment(rowData["last_modified"]).format("MM/DD/YYYY")}</span>;
            }
        },
        {
            label: "Expiration",
            header: "EXPIRATION",
            key: "expiration",
            sortable: true,
            format: ({ rowData }) => {
                return <span>{rowData["expiration_date"] ? moment(rowData["expiration_date"]).format("MM/DD/YYYY") : '-'}</span>;
            }
        },
        {
            label: "Permission Level",
            header: "PERMISSION LEVEL",
            key: "permission_level",
            sortable: true,
            format: ({ rowData }) => {
                return <span>{rowData["admins_only"] ? 'Admins' : (rowData["permission_department"] ? 'Department' : (rowData["permission_site"] ? 'Site' : 'Org'))}</span>;
            }
        },
        {
            label: "Actions",
            key: "actions",
            format: ({ rowData, customTableProps }) => {
                return (
                    <ItemActionsMenu
                    ref={actionMenuDropDown}
                        actions={(() => {

                            return  rowData.type === 'folder' ? [
                                {
                                    label: "View",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.view(rowData);
                                    }
                                },
                                {
                                    label: "Download Folder",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                            customTableProps.download(rowData)
                                        }
                                },
                                {
                                    label: "Upload Documents",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.upload({ rowData })
                                        }
                                },
                                {
                                    label: "Edit Permissions",
                                    action: () => {
                                        console.log("Action edit", rowData);
                                        customTableProps.edit(rowData);
                                    }
                                },
                                {
                                    label: "Delete",
                                    action: () => {
                                        console.log("Action delete", rowData);
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.delete(rowData);
                                    }
                                }
                            ] 
                            
                            :
                            [
                                // {
                                //     label: "View",
                                //     action: () => {
                                //         if (actionMenuDropDown && actionMenuDropDown.current){
                                //             actionMenuDropDown.current.handleMenuClose();
                                //         }
                                //         customTableProps.view(rowData);
                                //     }
                                // },
                               {
                                    label: "Download Document",
                                    action: () => {
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.download(rowData);
                                    }
                                },
                                // {
                                //     label: "Version History",
                                //     action: () => {
                                //         if (actionMenuDropDown && actionMenuDropDown.current){
                                //             actionMenuDropDown.current.handleMenuClose();
                                //         }
                                //         customTableProps.viewHistory(rowData);
                                //     }
                                // }
                                // ,
                                // {
                                //     label: "Edit File",
                                //     action: () => {
                                //         console.log("Action edit", rowData);
                                //         customTableProps.edit(rowData);
                                //     }
                                // },
                                {
                                    label: "Edit Permissions",
                                    action: () => {
                                        console.log("Action edit", rowData);
                                        customTableProps.editFilePermissions(rowData);
                                    }
                                },
                                {
                                    label: "Delete",
                                    action: () => {
                                        console.log("Action delete", rowData);
                                        if (actionMenuDropDown && actionMenuDropDown.current){
                                            actionMenuDropDown.current.handleMenuClose();
                                        }
                                        customTableProps.delete(rowData);
                                    }
                                }
                            ];
                        })()}
                    />
                );
            },
            // className: "col-actions",
            // header: ({ customTableProps }) => {
            //     return (
            //         <ColVisibilitySelector
            //             colDefs={customTableProps.colDefs}
            //             visibleColumnKeys={customTableProps.visibleColumnKeys}
            //             onChangeVisibility={colKey =>
            //                 customTableProps.onChangeVisibility(colKey)
            //             }
            //         />
            //     );
            // }
        }
    ]
};
